const config = {
  name: 'Carelon Wellbeing',
  rootUrl: 'https://mybeaconwellbeing.com',
  logoUrl: 'https://mybeaconwellbeing.com/assets/images/logo.png',
  meta: {
    separator: ' - ',
  },
  transitionDuration: 300,
};

const apiMap = {
  dev: 'https://devapp-th.carelonwellbeing.com/api/',
  //dev: 'http://54.153.91.155/api',
  stg: 'https://stgapp-th.carelonwellbeing.com/api/',
  // prod: 'https://app.mybeaconwellbeing.com/api/',
  prod:'https://app-th.carelonwellbeing.com/api/',
};

const newFrontEndurl = {
  dev: 'dev-th.carelonwellbeing.com/',
  stg: 'stg-th.carelonwellbeing.com/',
  prod:'th.carelonwellbeing.com/',
};

const redirectiondfd = {
  dev: 'https://devt.carelonwellbeing.com/',
  stg: 'https://devt.carelonwellbeing.com/',
  prod: 'https://www.carelonwellbeing.com/',
};

const mdLiveApiMap = {
  // dev: 'https://stage-rest-api.mdlive.com/api',
  dev: 'https://stage-rest-api.mdlivetechnology.com/api',
  stg: 'https://rest-api.mdlive.com/api',
  prod: 'https://rest-api.mdlive.com/api',
};

const analyticsMap = {
  dev: 'UA-134644982-1',
  qa: 'UA-134644982-2',
  stg: 'UA-134644982-3',
  prod: 'UA-134644982-4',
};

const envMap = {
  development: 'dev',
  qa: 'qa',
  stg: 'stg',
  production: 'prod',
};

const contentfulMap = {
  dev: 'jcBmNShpsahSeg5ouPFr_ScxHE5uiIr2FOZfrzkRbVU',
  qa: 'jcBmNShpsahSeg5ouPFr_ScxHE5uiIr2FOZfrzkRbVU',
  prod: 'jcBmNShpsahSeg5ouPFr_ScxHE5uiIr2FOZfrzkRbVU',
};

contentfulMap.stg = contentfulMap.dev;

const contentfulEnv = {
  dev: 'dev',
  qa: 'dev',
  stg: 'dev',
  prod: 'master',
};

export const env = envMap[process.env.NODE_ENV] || 'dev'; // eslint-disable-line no-undef

export default {
  ...config,
  env,
  api: apiMap[env],
  frontendurl: newFrontEndurl[env],
  dfdredirection: redirectiondfd[env],
  analytics: analyticsMap[env],
  mdLiveApi: mdLiveApiMap[env],
  contentful: {
    space: '18y461exyo0p',
    environment: contentfulEnv[env],
    accessToken: contentfulMap[env],
  },
};

console.log('ENV: ', env);



// WEBPACK FOOTER //
// ./client/config.js